import {useEffect} from 'react';
import './bottomSheet.module.scss';
import {
  AnimatePresence,
  motion,
  useMotionValue,
  useTransform,
} from 'framer-motion';
import Portal from 'components/portal';

interface CustomBottomSheetProps {
  isOpen: boolean;
  children: React.ReactNode;
  onDismiss: () => void;
  questions?: boolean;
}
const CustomBottomSheet = ({
  isOpen,
  children,
  onDismiss,
  questions,
}: CustomBottomSheetProps) => {
  const dragY = useMotionValue(0);
  const sheetY = useTransform(
    dragY,
    [0, window.innerHeight],
    [0, window.innerHeight],
  );

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  const handleDragEnd = (_, info) => {
    const {offset, velocity} = info;
    if (offset.y > 100 || velocity.y > 500) {
      onDismiss();
    }
  };

  return (
    <Portal>
      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              initial={{opacity: 0}}
              animate={{opacity: 0.5}}
              exit={{opacity: 0}}
              transition={{duration: 0.3}}
              className="fixed inset-0 bg-black z-40 "
              onClick={onDismiss}
            />
            <motion.div
              initial={{translateY: '100%', opacity: 0}}
              animate={{translateY: '0%', opacity: 1}}
              exit={{translateY: '100%', opacity: 0}}
              transition={{duration: 0.3}}
              className="fixed left-0 bottom-0 w-full bg-white shadow-md z-50 p-4 rounded-t-lg"
              style={{y: sheetY}}
              drag="y"
              dragConstraints={{top: 0, bottom: 0}}
              onDragEnd={handleDragEnd}
              dragElastic={0.2}
            >
              {/* Content of the bottom sheet */}
              {questions ? (
                <div className="overflow-y-scroll h-96">{children}</div>
              ) : (
                children
              )}
            </motion.div>
          </>
        )}
      </AnimatePresence>{' '}
    </Portal>
  );
};

export default CustomBottomSheet;
